import { formatFieldLabel } from '../lib/contentUtils';

export function FieldBlock({ fields }: { fields: Record<string, string> }) {
  const entries = Object.entries(fields).filter(([, v]) => v?.trim());

  return (
    <div className="field-blocks">
      {entries.map(([key, value]) => (
        <section key={key} className="field-block">
          <h3>{formatFieldLabel(key)}</h3>
          <div className="field-body">{value.split('\n').map((line, i) => (
            <p key={i}>{line}</p>
          ))}</div>
        </section>
      ))}
    </div>
  );
}
